<template>
	<NP-Modal :toggle="toggle" label="Змінити ПНФП">
		<div class="transfer-workplace-body">
			<form @submit.prevent="submitBarcode" v-if="!workplace">
				<p>Щоб перезакріпитися на цьому ПНФП: відскакуйте штрих-код на робочому місці та натисніть Enter</p>
				<NP-Input
					v-model="code"
					label="ШК"
					:error="error"
					:has-error="Boolean(error)"
					:disabled="loadingActions.includes('findWorkplace')"
				/>
			</form>
			<div v-else-if="workplace.salepoint_code === salepoint.code">
				<p>Ваше поточне ПНФП не вiдрiзняється вiд ПНФП робочого місця.</p>
				<div class="buttons">
					<NP-Button priority="low-borderless" @click="toggle">
						Закрити
						<div class="icon-close" slot="icon" />
					</NP-Button>
				</div>
			</div>
			<div v-else>
				<p>Ви намагаєтеся закріпитися на ПНФП:</p>
				<p class="code">{{ workplace.salepoint_name }}</p>
				<div class="buttons">
					<NP-Button priority="low-borderless" @click="toggle">
						Скасувати
						<div class="icon-close" slot="icon" />
					</NP-Button>
					<NP-Button
						priority="high"
						@click.stop="transfer"
						:loading="rootLoadingActions.includes('transferUserToAnotherSalepoint')"
					>
						Підтвердити
					</NP-Button>
				</div>
			</div>
		</div>
	</NP-Modal>
</template>

<script>
export default {
	name: 'TransferWorkplaceModal',
	props: {
		workplace: { type: Object, default: () => null },
		salepoint: { type: Object, default: () => null },
		loadingActions: { type: Array, default: () => [] },
		rootLoadingActions: { type: Array, default: () => [] },
		toggle: { type: Function, default: null },
		transferUserToAnotherSalepoint: { type: Function, default: null },
		findWorkplace: { type: Function, default: null }
	},
	data() {
		return { code: '', error: null };
	},
	methods: {
		submitBarcode() {
			this.error = null;
			let { code } = this;
			code = (code || '').trim();
			if (!code || !code.startsWith('433') || !/^[0-9-]+$/.test(code) || code.length < 5 || code.length > 11) {
				this.error = 'ШК введено невiрно';
				return;
			}
			code = code.replace(/\D/g, '').substr(3);
			return this.findWorkplace({ code, loadingAction: true });
		},
		transfer() {
			return this.transferUserToAnotherSalepoint({ id: this.workplace.salepoint_id, loadingAction: true });
		}
	}
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/variables.scss';
@import '@assets/scss/mixins.scss';

$icon-close: '~@assets/images/icon-close.svg';

::v-deep .modal-body {
	padding-top: 0 !important;
	width: 400px;
}
p {
	padding: 20px 0;
}
.code {
	padding: 10px;
	margin-bottom: 20px;
	background: $gray-5;
	border-radius: 4px;
}
.buttons {
	display: flex;
	justify-content: space-between;
	.icon-close {
		@include make-icon($icon-close, $gray-40, 20px, 20px);
	}
}
</style>
